import Home from "../pages/User/Home/Home";
import AboutUs from "../pages/User/AboutUs/AboutUs";
import ContactUs from "../pages/User/ContactUs/ContactUs";
import Profile from "../pages/User/Profile";
import ProtectedRoute from "./PrivateRoute";
import TermsAndConditions from "../pages/User/TermsandConditions/TermsAndConditions";
import PaymentPolicy from "../pages/User/PaymentPolicy/PaymentPolicy";
import Courses from "../pages/User/Courses/Courses";
import Course from "../pages/User/Courses/Course/Course";
import MyCourses from "../pages/User/MyCourses/MyCourses";
import MyCourse from "../pages/User/MyCourses/MyCourse/MyCourse";
import MyVideo from "../pages/User/MyCourses/MyCourse/MyVideo/MyVideo";
import InstructorProfile from "../pages/User/Instructors/InstructorProfile/InstructorProfile";
import CourseGenAI from "../pages/User/Courses/CourseGenAI/CourseGenAI";
import HowToPurchase from "../pages/User/HowToPurchase/HowToPurchase";

var UserRoutes = [
  {
    path: "/",
    name: "Home",
    element: <Home />,
  },
  {
    path: "/courses",
    name: "Courses",
    element: <Courses />,
  },
  {
    path: "/my-profile",
    name: "My Profile",
    element: (
      <ProtectedRoute allowedRoles={["user"]}>
        <Profile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/my-courses",
    name: "My Courses",
    element: (
      <ProtectedRoute allowedRoles={["user"]}>
        <MyCourses />
      </ProtectedRoute>
    ),
  },
  {
    path: "/my-courses/:slug",
    name: "My Course",
    element: (
      <ProtectedRoute allowedRoles={["user"]}>
        <MyCourse />
      </ProtectedRoute>
    ),
  },
  
  {
    path: "/my-courses/:slug/:videoSlug",
    name: "My Video",
    element: (
      <ProtectedRoute allowedRoles={["user"]}>
        <MyVideo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/about",
    name: "About Us",
    element: <AboutUs />,
  },
  {
    path: "/contact",
    name: "Contact Us",
    element: <ContactUs />,
  },
  {
    path: "/how-to-purchase",
    name: "How to Purchase",
    element: <HowToPurchase />,
  },
  {
    path: "/terms-and-conditions",
    name: "Terms and Conditions",
    element: <TermsAndConditions />,
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    element: <PaymentPolicy />,
  },
  {
    path: "/courses/:slug",
    name: "Course",
    element: <CourseGenAI />,
  },
  {
    path: "/mentors/:id",
    name: "Mentor",
    element: <InstructorProfile />,
  },
];
export default UserRoutes;
